import { Component, OnInit, Inject, EventEmitter, ViewChild, ElementRef, NgZone, Optional, Input, Output, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../variables/translate-service";
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { SC_Input } from "../../../common/input/SC_Input";
import { GlobalFunctionService } from '../../services/global-function.service';
import { CountryData } from '../../api/CountryGetAll';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sen-app-google-map-address',
  templateUrl: './google-map-address.component.html',
  styleUrls: ['./google-map-address.component.scss']
})
export class GoogleMapAddressComponent implements OnInit {
  @Input() fromCreateProject: string;
  
  @Output() address = new EventEmitter<Event>();
  @Input() selectedProjectLatLon: any;
  @Input() parentFormSubmitted: boolean;
  @ViewChild("locationSearch") public searchElementRef: ElementRef;
  // @ViewChild("manuallocationSearch") public manualsearchElementRef: ElementRef;
  // @ViewChild("manuallPostCodeSearch") public postCodemanualsearchElementRef: ElementRef;
  // @ViewChild("manuallCityCodeSearch") public citymanualsearchElementRef: ElementRef;





  public latitude: number;
  public longitude: number;
  public zoom: number;
  public mapLocation: any = {};
  public tHeight: any;
  manualForm: FormGroup;
  googleForm: FormGroup;
  manualFormFocus: boolean = true;
  googleFormFocus: boolean = false;
  countryArray: CountryData[];
  textGoogleSearch = new google.maps.places.PlacesService(document.createElement('div'));
  textGoogleSearchResult: any;
  manualCheckArray = ['street', 'postalCode', 'location'];
  getcheckboxValue: boolean = false;
  //  fullAddress : any;
  // splitAddress : any;
  // splitPostcode : any;
  // splitCity: any;
  // splitCityandPostcode:any;
  // selectManualAddress: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<GoogleMapAddressComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public globalF: GlobalFunctionService,
    private formBuilder: FormBuilder,
    public global: GlobalVariableService,
    private mapsAPILoader: MapsAPILoader,
    private _snackBar: MatSnackBar,
    private ngZone: NgZone) {
    this.globalF.getCountries().subscribe((data: CountryData[]) => {
      this.countryArray = data;
    });
    this.manualForm = this.formBuilder.group({
      street: [''],
      postalCode: [''],
      location: [''],
      countryISO: [this.global.deString],
      lat: [''],
      lon: [''],
      focus: [false]
    });
    this.googleForm = this.formBuilder.group({
      googleLocation: [''],
      focus: [true]      
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedProjectLatLon && changes.selectedProjectLatLon.currentValue) {
      this.latitude = parseFloat(this.selectedProjectLatLon.lat);
      this.longitude = parseFloat(this.selectedProjectLatLon.lon);
    }
    if (this.parentFormSubmitted) {
      this.googleForm.markAllAsTouched();
    }
  }

  ngOnInit(): void {
 
    this.getcheckboxValue = this.manualForm.get('focus')?.value;	
    localStorage.setItem('getcheckboxValue', this.getcheckboxValue+"");	


    // if (!this.data.address) {
    //   this.setFocus(false, true);

    // } else {
    //   this.setFocus(true, false);
    // }
    
    //set google maps defaults
    if (this.data.address?.street) {
      this.latitude = parseFloat(this.data.address.lat);
      this.longitude = parseFloat(this.data.address.lon);
      this.manualForm.get('street')?.setValue(this.data.address.street);
      this.manualForm.get('location')?.setValue(this.data.address.location);
      this.manualForm.get('postalCode')?.setValue(this.data.address.postalCode);
      this.manualForm.get('countryISO')?.setValue(this.data.address.countryISO);
      this.googleForm.get('googleLocation')?.setValue(`${this.data.address.street}, ${this.data.address.postalCode} ${this.data.address.location}, ${this.getCountry(this.data.address.countryISO)?.name}`);
      this.zoom = 20;

    } else {
      this.latitude = this.global.defaultLat;
      this.longitude = this.global.defaultLon;
      this.zoom = this.global.defaultMapZoom;
      //get default place height
      this.getTerHeight();
    }
    this.loadMapLocation(false);
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"],
        componentRestrictions: { country: SC_Input.sCountry }
      });

      // let manualAutocomplete = new google.maps.places.Autocomplete(this.manualsearchElementRef.nativeElement, {
      //   types: ["address"],
      //   componentRestrictions: { country: SC_Input.sCountry }
      // });

      // let manualPostCodeAutocomplete = new google.maps.places.Autocomplete(this.postCodemanualsearchElementRef.nativeElement, {
      //   types: ["(regions)"],
      //   componentRestrictions: { country: SC_Input.sCountry }
      // });

      // let manualCityAutocomplete = new google.maps.places.Autocomplete(this.citymanualsearchElementRef.nativeElement, {
      //   types: ["(cities)"],
      //   componentRestrictions: { country: SC_Input.sCountry }
      // });
      
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          // this.assignMap(place);
        });
      });

      // manualAutocomplete.addListener("place_changed", () => {
      //   this.ngZone.run(() => {
      //     //get the place result
      //     let place: google.maps.places.PlaceResult = manualAutocomplete.getPlace();
      //     //verify result
      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }
      //     this.selectManualAddress = true;
      //     this.assignMap(place);
      //   });
      // });


      // manualPostCodeAutocomplete.addListener("place_changed", () => {
      //   this.ngZone.run(() => {
      //     //get the place result
      //     let place: google.maps.places.PlaceResult = manualPostCodeAutocomplete.getPlace();
      //     //verify result
      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }
      //     this.selectManualAddress = true;
      //     this.assignMap(place);
      //   });
      // });

      // manualCityAutocomplete.addListener("place_changed", () => {
      //   this.ngZone.run(() => {
      //     //get the place result
      //     let place: google.maps.places.PlaceResult = manualCityAutocomplete.getPlace();

      //     //verify result
      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }
      //     this.selectManualAddress = true;
      //     this.assignMap(place);
      //   });
      // });



    });
  }
  
//   assignMap(place:any){
//     //set latitude, longitude and zoom
//     this.latitude = place.geometry.location.lat();
//     this.longitude = place.geometry.location.lng();
//     this.loadMapLocation();
//  }

  googleTextSearchService() {
    let checkArray: string[] = [];
    this.manualCheckArray.forEach(i => {
      let v = this.manualForm.get(i)!.value;
      if (v && v.length > 2) checkArray.push(v.toLowerCase());
    });
    if (checkArray.length >= 2) {
      let country = this.getCountry(this.manualForm.get('countryISO')!.value)!.name;
      let query = `${checkArray.join()},${country}`;
      this.textGoogleSearch.textSearch({ query: query }, (results, status) => {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          this.textGoogleSearchResult = results[0];
          this.latitude = this.textGoogleSearchResult.geometry.location.lat();
          this.longitude = this.textGoogleSearchResult.geometry.location.lng();
          this.loadMapLocation();
        }
      });
    }
  }

  getCountry(code: string) {
    return _.find(this.countryArray, { iso2: code });
  }

  setFocus(man: boolean, google: boolean) {	
    
    if (man) {	
      this.manualForm.get('focus')?.setValue(true);	
      this.googleForm.get('focus')?.setValue(false);	
      this.getcheckboxValue = this.manualForm.get('focus')?.value;	

      for (let item in this.googleForm.controls) {	
        this.googleForm.controls[item].setErrors(null);	
      }	
    } else {	
      this.manualForm.get('focus')?.setValue(false);	
      this.googleForm.get('focus')?.setValue(true);	
      this.getcheckboxValue = this.manualForm.get('focus')?.value;	

      for (let item in this.manualForm.controls) {	
        this.manualForm.controls[item].setErrors(null);	
      }	
    }	
    localStorage.setItem('getcheckboxValue', this.getcheckboxValue+"");	
  }


  markerDragEnd(event: MouseEvent) {
    this.latitude = event.coords.lat;
    this.longitude = event.coords.lng;
    this.loadMapLocation();
  }

  loadMapLocation(setfocus: boolean = true) {
    const geocoder = new google.maps.Geocoder();
    const latlng = new google.maps.LatLng(this.latitude, this.longitude);
    const request = {
      location: latlng
    };
    geocoder.geocode(request, (results: any) => {
      let route = "";
      this.ngZone.run(() => {
        if (results[0]) {
          this.googleForm.get('googleLocation')?.setValue(results[0].formatted_address);
          this.mapLocation = results[0];

          // if(this.selectManualAddress){
          //     this.displayManualAddress(); 
          // }

        }
      })
    });
    this.zoom = 20;
    if (setfocus){
      this.getTerHeight();
        // this.setFocus(false, true);

    }
  }

  getTerHeight() {
    if (this.data.reqHeight) {
      const latlng = new google.maps.LatLng(this.latitude, this.longitude);
      let elevator = new google.maps.ElevationService;
      elevator.getElevationForLocations({
        'locations': [latlng]
      }, (results, status) => {
        if (status === google.maps.ElevationStatus.OK) {
          // Retrieve the first result
          if (results[0]) {
            this.tHeight = Math.trunc(results[0].elevation);
          } else {
            console.log('No results found');
          }
        } else {
          console.log('Elevation service failed due to: ' + status);
        }
      });
    }
  }

  getAddress() {
    let streeNum = "";
    let route = "";
    this.mapLocation.address_components.find((x: any) => {
      if (x.types.includes("route")) {
        route = x.long_name;

      }
    });
    this.mapLocation.address_components.find((x: any) => {
      if (x.types.includes("street_number")) {
        streeNum = x.long_name;

      }
    });

    if (streeNum == "" || route == "") {
      return this.mapLocation.address_components[0].long_name
    }

    return `${route}, ${streeNum}`;
  }

  getCity() {
    let city = "";
    this.mapLocation.address_components.find((x: any) => {
      if (x.types.includes("locality")) city = x.long_name;
    });
    return city;
  }

  getCountryCode() {
    let iso: string = '';
    this.mapLocation.address_components.find((x: any) => {
      if (x.types.includes("country")) iso = x.short_name;
    });
    return iso.toLowerCase();
  }

  getZip() {
    let zip = "";
    this.mapLocation.address_components.find((x: any) => {
      if (x.types.includes("postal_code")) zip = x.long_name;
    });
    return zip;
  }

  resetLocationBar() {
    this.googleForm.reset();
  }

  closeDialogue(action: boolean) {
    if (action) {
      if (this.manualForm.get('focus')?.value) {
        this.googleForm.setErrors(null);
        let mValid = true;
        if (!this.manualForm.get('street')?.value) {
          this.manualForm.get('street')?.setErrors({});
          mValid = false;
        }
        if (!this.manualForm.get('location')?.value) {
          this.manualForm.get('location')?.setErrors({});
          mValid = false;
        }
        if (!this.manualForm.get('postalCode')?.value) {
          this.manualForm.get('postalCode')?.setErrors({});
          mValid = false;
        }
        if (!mValid) {
          this.manualForm.markAllAsTouched();
          return;
        }
      } else if (!this.googleForm.get('googleLocation')?.value) {
        this.manualForm.setErrors(null);
        this.googleForm.get('googleLocation')?.setErrors({});
        this.googleForm.markAllAsTouched();
        return;
      }
      if (this.googleForm.get('focus')?.value) {
        this.mapLocation.full = `${this.getAddress()}, ${this.getZip()} ${this.getCity()}, ${this.getCountry(this.getCountryCode())!.name}`;
        this.mapLocation.street = this.getAddress();
        this.mapLocation.location = this.getCity();
        this.mapLocation.postalCode = this.getZip();
        this.mapLocation.countryISO = this.getCountryCode();
      } else {
        this.mapLocation.full = `${this.manualForm.get('street')?.value}, ${this.manualForm.get('postalCode')?.value} ${this.manualForm.get('location')?.value}, ${this.getCountry(this.manualForm.get('countryISO')!.value)!.name}`;
        this.mapLocation.street = this.manualForm.get('street')?.value;
        this.mapLocation.location = this.manualForm.get('location')?.value;
        this.mapLocation.postalCode = this.manualForm.get('postalCode')?.value;
        this.mapLocation.countryISO = this.manualForm.get('countryISO')?.value;
      }
      this.mapLocation.lat = this.latitude;
      this.mapLocation.lon = this.longitude;
      this.mapLocation.zoom = this.zoom;
      this.mapLocation.tHeight = this.tHeight;
      this.dialogRef.close(this.mapLocation);
    } else {
      this.dialogRef.close();
    }
  }
  

// displayManualAddress(){
//     this.setFocus(true, false);

//     this.splitAddress = this.getAddress();
//     this.splitCity = this.getCity();
//     this.splitPostcode = this.getZip();
//     this.manualForm.get('street')?.setValue(this.splitAddress);
//     this.manualForm.get('location')?.setValue( this.splitCity);
//     this.manualForm.get('postalCode')?.setValue(this.splitPostcode) ;
//     this.selectManualAddress = false;
// }

}

